import { Modal, Box, Button, TextField } from "@mui/material";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { CREATE_KANBAN_TEAM_MEMBER } from "../../gql/mutations/kanban";

function AddTeamMember({ open, onClose, projectId, onMemberAdded }) {
  const [memberName, setMemberName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");

  const handleSave = async () => {
    await createTeamMember({
      variables: {
        data: {
          projectId,
          name: memberName,
          email,
          description,
        },
      },
    });
    if (onMemberAdded) onMemberAdded();
    onClose();
  };
  const [createTeamMember] = useMutation(CREATE_KANBAN_TEAM_MEMBER);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          padding: 4,
          backgroundColor: "white",
          margin: "auto",
          mt: "10%",
          width: 400,
        }}
      >
        <h2>Add Team Member</h2>
        <TextField
          label="Member Name"
          fullWidth
          margin="normal"
          value={memberName}
          error={!memberName.trim()}
          helperText={!memberName.trim() ? "Member Name is required" : ""}
          onChange={e => setMemberName(e.target.value)}
        />
        <TextField
          label="Email"
          fullWidth
          margin="normal"
          value={email}
          error={!email.trim()}
          helperText={!email.trim() ? "Email is required" : ""}
          onChange={e => setEmail(e.target.value)}
        />
        <TextField label="Description" fullWidth margin="normal" value={description} onChange={e => setDescription(e.target.value)} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose} sx={{ mr: 2 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!email.trim() || !memberName.trim()} // disable if empty or only spaces
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddTeamMember;
